function lazyLoadImages() {
    const images = document.querySelectorAll('#content img, .do-animate');
        transDely = 0;
        images.forEach(img => {
            const viewportHeight = window.innerHeight;
            const rect = img.getBoundingClientRect();
            const topPassedTopThird = rect.top < viewportHeight * 0.8;
            if (topPassedTopThird && rect.bottom > 0) {
                if (img.classList.contains('loaded') === false) {
                    if (img.dataset.src) {
                        img.src = img.dataset.src;
                        img.dataset.src = "";
                    }
                    img.style.transitionDelay = (transDely * 0.10) + 's';
                    console.log(img);
                    img.dataset.delay = transDely;
                    transDely++;
                    if(img.src) {
                        img.onload = function() {
                            img.classList.add('loaded');
                        };
                    } else {
                        img.classList.add('loaded');
                    }
                }
            }

        });
    };
window.addEventListener('load',function() {
    
    const trigger = document.getElementById("trigger");
    if(trigger) {        
        trigger.addEventListener("click", function (el) {
            var el = document.getElementById("trigger");
            if (el.classList.contains("open")) {
                el.classList.remove("open");
                document.querySelector("body").classList.remove("scroll-lock");
                document.getElementById("mobile_menu").classList.remove("open");
            } else {
                el.classList.add("open");
                document.querySelector("body").classList.add("scroll-lock");
                document.getElementById("mobile_menu").classList.add("open");
            }
        });
    }

    const map = this.document.querySelector('.map');

    const arrow = `<svg xmlns="http://www.w3.org/2000/svg" width="21.789" height="21.487" viewBox="0 0 21.789 21.487"><g id="Group_16" data-name="Group 16" transform="translate(-1328.126 -437.624)"><path id="Path_133" data-name="Path 133" d="M-99.812,1586.386H-84.5v14.391" transform="translate(1433.161 -1147.512)" fill="none" stroke="#fc6d6d" stroke-width="2.5"/><path id="Path_134" data-name="Path 134" d="M0,0H26.479" transform="translate(1347.733 439.505) rotate(135)" fill="none" stroke="#fc6d6d" stroke-width="2.5"/></g></svg>`;
    
    if(map) {
        if(map.querySelector('svg').classList.contains('logged-in')) {
            var img = document.createElement('img');
            img.classList.add('overlay');
            img.src = "/wp-content/themes/nelus-wordpress-theme/images/map.png";
            map.appendChild(img);
        }
        var member;
        var as = []
        for (const key in members) {
            if (members.hasOwnProperty(key)) {
                var member = members[key];
                var a = null;
                if(!member.no_link) {
                    a = document.createElement('a');
                    a.setAttribute('href', member.link);
                    a.setAttribute('rel', 'noopener');
                } else {
                    a = document.createElement('span');
                }
                a.classList.add('marker');
                a.setAttribute('data-id', member.id);
                a.style.left = member.x + '%';
                a.style.top = member.y + '%';
                a.innerHTML = star;
                var title_parts = member.title.split(' ');
                title_parts[title_parts.length - 1] = '<span class="arrow">' + title_parts[title_parts.length - 1] + arrow + '</span>'; 
                a.dataset.title = title_parts.join(' ');
                a.country = member.country;
                as.push(a);
                if(!member.no_link) {
                    a.addEventListener('mouseover', function(e) {
                        const label = map.querySelector('.label');
                        label.querySelector('strong').innerHTML = this.dataset.title;
                        label.querySelector('.country').textContent = this.country;
                        label.classList.add('active');
                    });
                    a.addEventListener('mouseout', function(e) {
                        const label = map.querySelector('.label');
                        label.classList.remove('active');
                    });
                }
                map.appendChild(as[as.length - 1]);
            }
        }
    }

    document.querySelectorAll('header .logo svg').forEach(el => el.classList.add('animate'));

    images = document.querySelectorAll('#content img');
    images.forEach(img => {
        if (!img.dataset.src && img.src && !img.classList.contains('loaded')) {
            img.dataset.src = img.src;
            img.src = '';
        }
    });

    window.addEventListener('scroll', function() {
        const header = document.querySelector('header');
        var scrollY = window.scrollY;
        if(scrollY > header.clientHeight && scrollY < this.scrollMem) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
        this.scrollMem = scrollY;
        lazyLoadImages();
    });
    lazyLoadImages();

    if(document.querySelector('#mobile_menu .contact')) {
    document.querySelector('#mobile_menu .contact').addEventListener('click', function(e) {
        var el = document.getElementById("trigger");
        console.log(el);
        el.classList.remove("open");
        document.querySelector("body").classList.remove("scroll-lock");
        document.getElementById("mobile_menu").classList.remove("open");
    });
    }

    document.querySelectorAll('.event').forEach(el => {
        id = el.getAttribute('id');
        el.querySelectorAll('.toggle').forEach(toggle => {
            toggle.addEventListener('click', function(e) {
                el.querySelector('.event-content').classList.toggle('show');
                lazyLoadImages();
                if (!el.querySelector('.event-content').classList.contains('show')) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            });
        });
    });

})